import {ArrowLeftIcon, ArrowRightIcon} from '@heroicons/react/24/outline';
import {ComponentProps} from 'react';

import NormalButton from './NormalButton';

type ArrowDirection = 'left' | 'right';

type Props = Omit<ComponentProps<typeof NormalButton>, 'left' | 'right'> & {
  direction: ArrowDirection;
};

const ArrowButton = ({direction, ...props}: Props) => {
  return (
    <NormalButton
      left={direction === 'left' && <ArrowLeftIcon className="sm w-sm" />}
      right={direction === 'right' && <ArrowRightIcon className="h-sm w-sm" />}
      {...props}
    />
  );
};

export default ArrowButton;
